<template>
  <div class="center-warp consumables">
    <div class="inner warp-page" v-loading="loading" style="height: fit-content">
      <div class="consumables-detail d-flex">
        <img alt="" class="consumables-detail-img" :src="product.main_pic">
        <div style="position: relative">
          <div class="consumables-info1">{{product.name}}</div>
          <div class="consumables-info2">分类：{{product.category_name}};{{product.type == 1 ? '定制耗材' : '标准耗材'}}</div>
          <div class="consumables-info2">耗材编号：{{product.code}}</div>
          <div class="consumables-info2 limit-7">{{product.desc}}</div>
          <div class="take-btn" v-if="member.member_type == 0" @click="handleOpen">领取耗材</div>
        </div>
      </div>
      <div>
        <div class="consumables-detail-title flex-center-center">
          <div class="left-line"></div>
          <span>产品详情</span>
          <div class="right-line"></div>
        </div>
        <div class="consumables-detail-cont" v-html="product.content"></div>
      </div>

      <ReceiveDialog ref="receiveDialog" :productId="productId" :product="product" />

    </div>
  </div>
</template>

<script>
import { info } from "@/http/product";
import ReceiveDialog from "@/views/consumables/components/ReceiveDialog";

export default {
  name: "detail",
  components: { ReceiveDialog },
  data() {
    return {
      product: {},
      productId: undefined,
      loading: false,
      member: {},
    };
  },
  mounted() {
    this.$store.commit("breadChange", {
      name: "耗材商城详情",
      isBack: true,
      url: "/consumables",
    });
    this.productId = this.$route.params.id;
    this.getData();
    var member = JSON.parse(localStorage.getItem("member"));
    this.member = member;
  },

  methods: {
    getData() {
      this.loading = true;
      info({ id: this.productId }).then((res) => {
        this.product = res.data;
        this.loading = false;
      });
    },
    handleOpen() {
      this.$refs.receiveDialog.handleOpen();
    },
  },
};
</script>


<style scoped src="../../assets/css/consumables.css">
</style>>
<style>
.add-data-item-input input,
.add-data-item .el-cascader input {
  width: 168px;
  height: 34px;
  background: #f4f4f4;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  border: none;
  padding-left: 10px !important;
}
.consumables-detail-cont *{
  max-width: 100%;
}
</style>
